import { useTranslation } from 'react-i18next';

import cn from 'classnames';

interface WebinarSeatsInfoProps {
  remainingSeats: number | undefined;
  maxSeats: number | undefined;
  className?: string;
}

const URGENT_SEAT_COUNT = 5;
const URGENT_FILL_RATIO = 0.9;
const WARNING_SEAT_COUNT = 10;
const WARNING_FILL_RATIO = 0.8;

type CapacityState = 'urgent' | 'warning' | 'normal';

function getCapacityState(remainingSeats: number, maxSeats: number): CapacityState {
  if (maxSeats <= 0) return 'normal';
  const fillRatio = (maxSeats - remainingSeats) / maxSeats;
  if (fillRatio >= URGENT_FILL_RATIO || (fillRatio > 0 && remainingSeats <= URGENT_SEAT_COUNT)) return 'urgent';
  if (fillRatio >= WARNING_FILL_RATIO || (fillRatio > 0 && remainingSeats <= WARNING_SEAT_COUNT)) return 'warning';
  return 'normal';
}

const WebinarSeatsInfo = ({ remainingSeats, maxSeats, className }: WebinarSeatsInfoProps) => {
  const { t } = useTranslation();

  if (typeof remainingSeats !== 'number' || typeof maxSeats !== 'number' || remainingSeats <= 0) {
    return null;
  }

  const state = getCapacityState(remainingSeats, maxSeats);

  const message =
    state === 'urgent'
      ? t('products.webinar.capacity_urgent', { count: remainingSeats })
      : state === 'warning'
        ? t('products.webinar.capacity_warning', { count: remainingSeats })
        : t('products.webinar.seats_left', { count: remainingSeats });

  return <p className={cn('text-center text-sm w-full', className)}>{message}</p>;
};

export default WebinarSeatsInfo;
